import styled, { css } from 'styled-components';

import { CUST } from '../../../../theme/customizer-tokens';
import { SPACE } from '../../../../theme/tokens';

/** Desktop = large light field; mobile = dark field with a leading globe. */
export const Field = styled.div<{ $variant: 'desktop' | 'mobile' }>`
  display: flex;
  align-items: center;
  gap: ${SPACE[12]};
  width: 100%;

  ${({ $variant }) =>
    $variant === 'desktop'
      ? css`
          height: 72px;
          padding: ${SPACE[12]} ${SPACE[24]};
          border-radius: 22px;
          background: ${CUST.connectInputBg};

          /* No border of its own: the focus draws a ring in the brand's orange. */
          &:focus-within {
            box-shadow: 0 0 0 2px ${CUST.accent};
          }
        `
      : css`
          height: 56px;
          padding: 0 ${SPACE[16]};
          border-radius: 14px;
          background: ${CUST.mobileFieldBg};
          border: 1px solid ${CUST.mobileHairline};

          &:focus-within {
            border-color: ${CUST.accent};
          }
        `}
`;

/** Leading globe (mobile only). */
export const Globe = styled.span<{ $variant: 'desktop' | 'mobile' }>`
  flex: 0 0 auto;
  display: inline-flex;
  color: ${({ $variant }) => ($variant === 'desktop' ? CUST.connectInputText : CUST.textMuted)};
`;

export const Input = styled.input<{ $variant: 'desktop' | 'mobile' }>`
  flex: 1 1 auto;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  font-family: inherit;
  ${({ $variant }) =>
    $variant === 'desktop'
      ? css`
          font-size: 24px;
          font-weight: 700;
          line-height: 1.2;
          color: ${CUST.connectInputText};
        `
      : css`
          font-size: 16px;
          font-weight: 500;
          color: ${CUST.white};
        `}

  &::placeholder {
    font-weight: 500;
    color: ${({ $variant }) => ($variant === 'desktop' ? CUST.connectInputPlaceholder : CUST.textMuted)};
  }

  &:read-only {
    cursor: default;
  }
`;

/** Green validity tick (shown once the typed value looks like a domain). */
export const Check = styled.span`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 9999px;
  background: ${CUST.connectCheck};
  color: ${CUST.onAccent};
`;